import { getSessionId } from '@aspendental/shared-utils/utils';
import pino, { Logger, LoggerOptions } from 'pino';
const logLevelData = {
	'*': 'silent',
	client: 'info',
	app: 'info',
	'preview-api': 'info',
	'landing-page': 'info',
	home: 'info',
	vetspire: 'info',
	'user-portal': 'info',
	'scheduled-appointments': 'info',
	'schedule-existing': 'info',
	'reason-for-visit': 'info',
	'patient-selection': 'info',
	'404-page': 'info',
	'500-page': 'info',
	'appointment-review': 'info',
	'appointment-selection': 'info',
	'client-registration': 'info',
	confirmation: 'info',
	'patient-registration': 'info',
	'patient-health-info': 'info',
	'contact-office': 'info',
	'intake-forms': 'info',
	login: 'info',
	'focused-questions': 'info',
	'firebase-email-otp-server': 'info',
	'client-email-otp-request': 'info',
	'client-email-otp-authenticate': 'info',
	'client-phone-authenticate': 'info',
	'client-phone-lookup': 'info',
};

const levelToSeverity = {
	trace: 'DEBUG',
	debug: 'DEBUG',
	info: 'INFO',
	warn: 'WARNING',
	error: 'ERROR',
	fatal: 'CRITICAL',
};

const logLevels = new Map<string, string>(Object.entries(logLevelData));

export function getLogLevel(logger: string): string {
	return logLevels.get(logger) || logLevels.get('*') || 'info';
}

export function getLogger(name: string): Logger {
	if (name === 'client') {
		return pino({
			name,
			browser: {
				asObject: true,
				transmit: {
					send: (level, logEvent) => {
						const msg = logEvent.messages[0] as string;
						const sessionId = getSessionId();

						const headers = {
							'Access-Control-Allow-Origin': '*',
							'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
							type: 'application/json',
						};
						const blob = new Blob([JSON.stringify({ msg, name, level, sessionId })], headers);

						if (navigator.sendBeacon) {
							navigator.sendBeacon(`${globalThis.location.origin}${process.env.APP_PATH}/api/log/`, blob);
						} else {
							void fetch(`${globalThis.location.origin}${process.env.APP_PATH}/api/log/`, {
								body: JSON.stringify({ msg, name, level, sessionId }),
								method: 'POST',
								keepalive: true,
								headers,
							});
						}
					},
				},
				disabled: process.env.NODE_ENV === 'production',
			} as LoggerOptions['browser'],
		});
	}
	const tagTheme = process.env.TAG_BRAND_THEME || 'lovet';
	const options: LoggerOptions = {
		name,
		formatters: {
			level(label, number) {
				return { severity: levelToSeverity[label], level: number };
			},
		},
		messageKey: 'message',
		level: getLogLevel(name),
		msgPrefix: `${tagTheme} `,
	};

	try {
		return pino({
			...options,
			transport: {
				target: process.env.NODE_ENV === 'production' ? 'pino/file' : 'pino-pretty',
				options: {
					colorize: true,
					destination: 1,
				},
			},
		});
	} catch {
		// Some runtimes/bundlers cannot resolve transport targets (for example pino-pretty in server bundles).
		// Fallback to the default destination so logging still works and app rendering does not crash.
		return pino(options);
	}
}
